"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PACKET = exports.CHILD = exports.ROOT = void 0;
exports.ROOT = 'common-redpacket';
exports.CHILD = 'common-redpacket/item';
exports.PACKET = 'common-redpacket/packet';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb25zdGFudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLElBQUksR0FBRyxrQkFBa0IsQ0FBQztBQUMxQixRQUFBLEtBQUssR0FBRyx1QkFBdUIsQ0FBQztBQUNoQyxRQUFBLE1BQU0sR0FBRyx5QkFBeUIsQ0FBQyJ9